/* global window */

/**
 * Command pattern for AppaltiMap frontend actions.
 * Pure UI orchestration: no plan/business logic, no Map Engine calls.
 */
(function (window) {
    window.AppaltiMap = window.AppaltiMap || {};

    function Command() {}
    Command.prototype.execute = function () {
        return Promise.resolve();
    };

    function ExchangeTokenCommand(client, magic) {
        this._client = client;
        this._magic = magic;
    }
    ExchangeTokenCommand.prototype = Object.create(Command.prototype);
    ExchangeTokenCommand.prototype.execute = function () {
        var client = this._client;
        return client.exchangeToken(this._magic).then(function (data) {
            if (data && data.token && data.expires_in) {
                client.tokenStore.setExchange(data.token, data.expires_in);
            }
            return data;
        });
    };

    function LoadClustersCommand(client, params) {
        this._client = client;
        this._params = params;
    }
    LoadClustersCommand.prototype = Object.create(Command.prototype);
    LoadClustersCommand.prototype.execute = function () {
        return this._client.getClusters(this._params);
    };

    function LoadTendersCommand(client, params) {
        this._client = client;
        this._params = params;
    }
    LoadTendersCommand.prototype = Object.create(Command.prototype);
    LoadTendersCommand.prototype.execute = function () {
        return this._client.getTenders(this._params);
    };

    window.AppaltiMap.Command = Command;
    window.AppaltiMap.ExchangeTokenCommand = ExchangeTokenCommand;
    window.AppaltiMap.LoadClustersCommand = LoadClustersCommand;
    window.AppaltiMap.LoadTendersCommand = LoadTendersCommand;
})(window);

